module.exports = __webpack_public_path__ + "media/img/colekeister156674-8db68709.jpg";